import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, takeUntil } from 'rxjs';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { CachePartidasService } from 'src/app/core/services/cache-partidas-service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { SaveLineItemBudget } from 'src/app/shared/models/guardar-partida-presupuesto';
import { Partida } from 'src/app/shared/models/partida';
import { BudgetItem } from 'src/app/shared/models/partida-presupuesto';

@Component({
  selector: 'app-capturar-partidas-presupuesto',
  templateUrl: './capturar-partidas-presupuesto.component.html',
  styleUrls: ['./capturar-partidas-presupuesto.component.css'],
  providers: [DatePipe, DecimalPipe]
})
export class CapturarPartidasPresupuestoComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  filterColumForm = new FormGroup({
    filterDetails: new FormControl('0'),
    descriptionFilter: new FormControl('', [Validators.minLength(3), Validators.maxLength(100)]),
  });
  dataSourceFilters = new MatTableDataSource<Partida>;
  nroRegistros: number = 0;
  displayedColumns: string[] = ['reference', 'code', 'description', 'unit', 'lowPerformance', 'lineItemGrouping'];
  displayedColumnsSelected: string[] = ['reference', 'code', 'description', 'unit', 'lowPerformance', 'updateDate'];

  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  selectedRowIds: Set<string> = new Set<string>();
  listPartidasSeleccionadas: Partida[] = [];
  listPartidasPresupuesto: BudgetItem[] = [];
  disableButtonAddItem: boolean = true;
  listPartidasDataSource = new MatTableDataSource<Partida>;
  dataLoadedItems = new Map();

  totalItemsPage: number;
  dataListPartidas: Partida[];
  disableButtonfilter: boolean = true;
  typeAction: string;
  defaultFilterDetails = 'description';
  classFlag: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public pBudgetId: number,
    public dialogCapturarPartidasRef: MatDialogRef<CapturarPartidasPresupuestoComponent>,
    private cachePartidasService: CachePartidasService,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
  ) { }

  ngOnInit() {
    this.classFlag = this.helperClassService.validateViewMobileScreen(screen.width);
    this.filterColumForm.get('filterDetails')!.setValue(this.defaultFilterDetails);
    this.getAllLineItem();
    this.listPartidasPresupuesto = [];
    this.cachePartidasService.getAll().subscribe((data: BudgetItem[]) => {
      this.listPartidasPresupuesto = data;
    });
    this.cleanFilter();
  }

  getAllLineItem() {
    this.route = '/getLineItemByDatePage';
    this.method = 'POST';
    this.totalItemsPage = 0;
    this.typeAction = 'filterAll';

    let data = {
      oilCompany: false,
      year: Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear()),
      month: Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) ? Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT)) : (new Date().getMonth() + 1)),
      page: (this.paginator ? (this.paginator.pageIndex) : 0),
      pageSize: (this.paginator ? this.paginator.pageSize : 25)
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(response => {

        if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
          this.totalItemsPage = response.data.total;
          this.dataListPartidas = response.data.content;
          this.dataSourceFilters = new MatTableDataSource(this.dataListPartidas);
          this.nroRegistros = this.totalItemsPage;

          for (let [i, item] of this.dataSourceFilters.data.entries()) {
            const reference = item.reference;
            if (!this.dataLoadedItems.has(reference)) {
              this.dataLoadedItems.set(reference, item);
            }
          }
          const uniqueItems = Array.from(this.dataLoadedItems.values());
          this.listPartidasDataSource.data = uniqueItems;

        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
        }
        this.apiCallService.hideSpinner();
      }, error => {
        this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          this.apiCallService.hideSpinner();
      }
      );
  }

  ngAfterViewInit() {
    this.dataSourceFilters.paginator = this.paginator;
    this.paginator.page.subscribe(() => {
      if (this.typeAction == 'filterColum') {
        this.applyFilterDetails();
      } else {
        this.getAllLineItem();
      }
    });
    this.dataSourceFilters.sort = this.sort;
  }

  cleanFilter() {
    this.filterColumForm.get('descriptionFilter')?.setValue('');
    if (this.filterColumForm.get('filterDetails')?.value === '0') {
      this.filterColumForm.get('descriptionFilter')?.disable();
      this.disableButtonfilter = true;
      this.paginator.pageIndex = 0;
      this.getAllLineItem();
    } else {
      this.filterColumForm.get('descriptionFilter')?.enable();
      this.disableButtonfilter = false;
    }
  }

  applyFilterDetails() {
    if (this.filterColumForm.invalid) {
      return;
    } else {
      this.typeAction = 'filterColum';
      let typeSearchValue = -1;
      let filterValue = this.filterColumForm.controls['descriptionFilter'].value;

      if (filterValue?.trim() != '') {
        let listFilterValue = filterValue?.trim().split(/\s/);
        if (listFilterValue?.length! <= 5) {
          let typeSearch = this.filterColumForm.controls['filterDetails'].value;
          if (typeSearch === 'lineItemGrouping') { typeSearchValue = 0 }
          if (typeSearch === 'description') { typeSearchValue = 1 }
          if (typeSearch === 'reference') { typeSearchValue = 2 }
          if (typeSearch === 'code') { typeSearchValue = 3 }

          this.route = '/getLineItemByConditionPage';
          this.method = 'POST';
          let data = {
            oilCompany: false,
            year: Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear()),
            month: Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) ? Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT)) : (new Date().getMonth() + 1)),
            page: (this.paginator ? (this.paginator.pageIndex) : 0),
            pageSize: (this.paginator ? this.paginator.pageSize : 25),
            typeSearch: typeSearchValue,
            conditionSearch: filterValue?.trim()
          }

          this.apiCallService.call$(data, this.route, this.method, true, '', true)
            .pipe(takeUntil(this.destroy$)).subscribe(response => {

              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.totalItemsPage = response.data.total;
                this.dataListPartidas = response.data.content;
                this.dataSourceFilters = new MatTableDataSource(this.dataListPartidas);
                this.nroRegistros = this.totalItemsPage;

                for (let [i, item] of this.dataSourceFilters.data.entries()) {
                  const reference = item.reference;
                  if (!this.dataLoadedItems.has(reference)) {
                    this.dataLoadedItems.set(reference, item);
                  }
                }
                const uniqueItems = Array.from(this.dataLoadedItems.values());
                this.listPartidasDataSource.data = uniqueItems;

              } else {
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              }
              this.apiCallService.hideSpinner();
            });
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_FILTER_SEARCH_LIMIT, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
        }
      } else {
        this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_VALUE_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
      }
    }
  }

  closeDialogCapturarPartidas() {
    this.selectedRowIds.clear();
    this.dataLoadedItems.clear();
    this.listPartidasDataSource.data = [];
    this.dialogCapturarPartidasRef.close();
  }

  onRowClick(id: string) {
    if (this.selectedRowIds.has(id)) {
      this.selectedRowIds.delete(id);
    } else {
      this.selectedRowIds.add(id);
    }
    this.listPartidasSeleccionadas = this.getSelectedRows();
    if (this.listPartidasSeleccionadas.length > 0) {
      this.disableButtonAddItem = false;
    } else {
      this.disableButtonAddItem = true;
    }
  }

  rowIsSelected(id: string) {
    return this.selectedRowIds.has(id);
  }

  getSelectedRows() {
    return this.listPartidasDataSource.data.filter(x => this.selectedRowIds.has(x.reference));
  }

  onSaveLineItemBudget() {
    let listIdLineItem: SaveLineItemBudget[] = [];
    let indexPosition = 0;

    for (indexPosition; indexPosition < this.listPartidasPresupuesto.length; indexPosition++) {
      let saveLineItemBudget: SaveLineItemBudget = {
        idLineItem: this.listPartidasPresupuesto[indexPosition].idLineItem,
        idLineItemUser: (this.listPartidasPresupuesto[indexPosition].idLineItemUser == 0 ? null : this.listPartidasPresupuesto[indexPosition].idLineItemUser),
        reference: this.listPartidasPresupuesto[indexPosition].reference,
        lineItemOrder: indexPosition
      }
      listIdLineItem.push(saveLineItemBudget);
    }

    for (let i = 0; i < this.getSelectedRows().length; i++) {
      indexPosition = (listIdLineItem.length > 0 ? (indexPosition) : 0);
      if (!this.cachePartidasService.validateId(this.getSelectedRows()[i].idLineItem.toString())) {
        let saveLineItemBudget: SaveLineItemBudget = {
          idLineItem: this.getSelectedRows()[i].idLineItem,
          idLineItemUser: null,
          reference: this.getSelectedRows()[i].reference,
          lineItemOrder: indexPosition
        }
        listIdLineItem.push(saveLineItemBudget);
      }
    }

    if (listIdLineItem.length > 0) {

      this.route = '/addLineItemToBudget';
      this.method = 'POST';
      let data = {
        LineItemList: listIdLineItem,
        idBudget: this.pBudgetId
      }

      this.apiCallService.call$(data, this.route, this.method, true, '', true)
        .pipe(takeUntil(this.destroy$)).subscribe(response => {

          if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
            let listPartidasAgregadas = response.properties.budgetLineItemTo;
            let lastPosition = (this.listPartidasPresupuesto.length > 0 ? this.listPartidasPresupuesto[(this.listPartidasPresupuesto.length - 1)].position : 0);

            for (let i = 0; i < listPartidasAgregadas.length; i++) {
              let partidaCapturada = listPartidasAgregadas[i];
              if (!this.cachePartidasService.validateId(partidaCapturada.idLineItem.toString())) {
                let partidaNueva: BudgetItem = {
                  position: lastPosition += 1,
                  chapterReference: '',
                  reference: partidaCapturada.referenceBudgetLineItem,
                  code: partidaCapturada.codeBudgetLineItem,
                  description: partidaCapturada.descriptionBudgetLineItem,
                  unit: partidaCapturada.unitName,
                  quantity: partidaCapturada.lineItemQuantity,
                  unitPrice: partidaCapturada.calculatedUnitPrice,
                  assumedPrice: partidaCapturada.assumedPrice,
                  total: (partidaCapturada.calculatedUnitPrice * partidaCapturada.lineItemQuantity),
                  performance: partidaCapturada.performance,
                  idLineItem: partidaCapturada.idLineItem,
                  lineItemGrouping: partidaCapturada.groupingDescription,
                  idBudgetLineItem: partidaCapturada.idBudgetLineItem,
                  idChapterReference: null,
                  descriptionChapter: '',
                  benefit: partidaCapturada.benefit,
                  administrativeExpense: partidaCapturada.administrativeExpense,
                  unexpectedUtility: partidaCapturada.unexpectedUtility,
                  financing: partidaCapturada.financing,
                  iva: partidaCapturada.iva,
                  otherTax: partidaCapturada.otherTax,
                  idLineItemUser: 0
                }
                this.cachePartidasService.save(partidaNueva.idLineItem.toString(), partidaNueva);
              }
            }

            if (this.cachePartidasService.validateIdOnBudget(Constanst.CACHE_MATERIAL_PRICE_REPLACE)) {
              this.cachePartidasService.modifyOnBudget(Constanst.CACHE_MATERIAL_PRICE_REPLACE, response.properties.materialPrice)
            } else {
              this.cachePartidasService.saveOnBudget(Constanst.CACHE_MATERIAL_PRICE_REPLACE, response.properties.materialPrice);
            }

            if (this.cachePartidasService.validateIdOnBudget(Constanst.CACHE_LABOR_PRICE_REPLACE)) {
              this.cachePartidasService.modifyOnBudget(Constanst.CACHE_LABOR_PRICE_REPLACE, response.properties.laborPriceTo);
            } else {
              this.cachePartidasService.saveOnBudget(Constanst.CACHE_LABOR_PRICE_REPLACE, response.properties.laborPriceTo);
            }

            if (this.cachePartidasService.validateIdOnBudget(Constanst.CACHE_EQUIPMENT_PRICE_REPLACE)) {
              this.cachePartidasService.modifyOnBudget(Constanst.CACHE_EQUIPMENT_PRICE_REPLACE, response.properties.equipmentPriceTo);
            } else {
              this.cachePartidasService.saveOnBudget(Constanst.CACHE_EQUIPMENT_PRICE_REPLACE, response.properties.equipmentPriceTo);
            }

            this.closeDialogCapturarPartidas();
          } else {
            this.closeDialogCapturarPartidas();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          }
          this.apiCallService.hideSpinner();
        });
    } else {
      this.closeDialogCapturarPartidas();
    }
  }

  resetPaginator(event: Event) {
    let filterValue = (event.target as HTMLInputElement).value.trim();
    if (filterValue == '') {
      this.paginator.pageIndex = 0;
      this.getAllLineItem();
    }
  }

}
